var map = {
	"./home-hero-bg.jpg": 9073,
	"./makhhash-feature-1.png": 736,
	"./makhhash-feature-2.png": 1283,
	"./makhhash-feature-3.png": 6599,
	"./mining/cloud-mining-hero-bg.jpg": 5300,
	"./mining/what-is-mining.jpg": 1835,
	"./mining/where-to-start.jpg": 7607,
	"./mining/why-makhmining.jpg": 846,
	"./support-hero-bg.jpg": 5848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2841;